// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hospitalSelection_wrapper__32mYR","errorMessage":"hospitalSelection_errorMessage__1kL0L"};